<template>
  <div id="home">
    <v-container grid-list-xl fluid class="ma-0 pa-3">
      <v-layout row wrap v-if="PuedoEditarConfiguracion()">
        <v-flex lg2 sm12 xs12>
          <v-card class="elevation-4" v-if="true">
            <v-toolbar dense color="primary" dark flat>
              <v-toolbar-title>Cliente</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                label="Código de Cliente"
                v-model="cliente"
                @input="resetConfig"
              ></v-text-field>
            </v-card-text>
            <div
              style="
                 {
                  text-align: center;
                }
              "
            >
              <v-btn
                dark
                block
                color="secondary"
                @click="eliminarConfiguracionCliente()"
                class="pa-0 ma-0"
                >Eliminar configuración</v-btn
              >
              <v-btn
                dark
                block
                color="secondary"
                @click="crearConfiguracionCliente()"
                class="pa-0 ma-0"
                >Crear configuración</v-btn
              >
              <v-btn
                dark
                block
                color="primary"
                class="pa-0 ma-0"
                @click="cargarConfiguracionCliente()"
                >Cargar configuración</v-btn
              >
            </div>
          </v-card>
        </v-flex>

        <v-flex lg10 sm12 xs12 :class="isMobile ? '' : 'ml-0 pl-0'">
          <v-card class="elevation-4">
            <v-toolbar :extended="false" color="primary" dark dense flat>
              <v-toolbar-title>Editar Configuración</v-toolbar-title>
              <v-spacer />
              <v-btn flat color="white" @click="eliminar()" v-if="false">
                <v-icon class="pr-1">delete</v-icon>Eliminar Configuración
              </v-btn>
              <v-btn flat color="white" @click="guardar()">
                <v-icon class="pr-1">save</v-icon>Guardar Configuración
              </v-btn>
            </v-toolbar>

            <v-card-text v-if="configuracion">
              <v-layout row wrap>
                <v-flex class="pa-2" xs12 sm6 md4>
                  <b-form-group
                    id="serviceType"
                    :label="
                      $t('servicios.formularioExpedicion.tipoServicio') +
                      ' - (' +
                      configuracion.CodigoTipoServicio +
                      ')'
                    "
                    label-for="serviceType"
                  >
                    <v-layout wrap>
                      <v-flex sm9 class="pr-0 mr-0">
                        <b-select
                          v-model="servicioSeleccionado"
                          @input="actualizarServicio"
                        >
                          <option
                            v-for="TipoServicio in servicesTypes"
                            :value="TipoServicio"
                            :key="TipoServicio.CODIGO"
                          >
                            {{ TipoServicio.NOMBRE }}
                          </option>
                        </b-select>
                      </v-flex>
                      <v-flex sm3 class="pl-0 ml-0">
                        <b-btn @click="cargarTiposServicio">
                          {{ $t("servicios.formularioExpedicion.refrescar") }}
                        </b-btn>
                      </v-flex>
                    </v-layout>
                  </b-form-group>
                </v-flex>

                <v-flex class="pa-2" xs12 sm6 md3 v-if="false">
                  <v-text-field
                    :label="$t('servicios.codigoTipoServicio')"
                    v-model="configuracion.CodigoTipoServicio"
                  ></v-text-field>
                </v-flex>

                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    :label="$t('servicios.formulario.referencia')"
                    v-model="configuracion.Referencia"
                  ></v-text-field>
                  <v-switch
                    color="primary"
                    v-model="configuracion.ForzadoDefinido"
                    label="Forz. Definido"
                    value="Referencia"
                  />
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-checkbox
                    color="primary"
                    v-model="configuracion.SolicitudCliente"
                    :label="$t('servicios.formulario.solicitudRecogidaPlaza')"
                  ></v-checkbox>
                  <v-switch
                    color="primary"
                    v-model="configuracion.ForzadoDefinido"
                    label="Forz. Definido"
                    value="SolicitudCliente"
                  />
                </v-flex>
              </v-layout>

              <!--Bloque horario -->
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-toolbar-title class="pa-0 ma-0"
                    >Horario Lunes-Jueves</v-toolbar-title
                  >
                  <v-layout row wrap>
                    <v-flex class="pa-2" xs12 sm6>
                      <b-form-group
                        center
                        id="time"
                        :label="
                          $t(
                            'servicios.formularioExpedicion.recogidaHoraInicial'
                          )
                        "
                        label-for="time"
                      >
                        <b-form-input
                          autocomplete="off"
                          id="time"
                          type="time"
                          v-model="configuracion.Horarios.LunJue.Inicio"
                        ></b-form-input>
                      </b-form-group>
                    </v-flex>
                    <v-flex class="pa-2" xs12 sm6>
                      <b-form-group
                        center
                        id="time"
                        :label="
                          $t(
                            'servicios.formularioExpedicion.recogidaHoraInicial'
                          )
                        "
                        label-for="time"
                      >
                        <b-form-input
                          autocomplete="off"
                          id="time"
                          type="time"
                          v-model="configuracion.Horarios.LunJue.Fin"
                        ></b-form-input>
                      </b-form-group>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-toolbar-title class="pa-0 ma-0"
                    >Horario Viernes</v-toolbar-title
                  >
                  <v-layout row wrap>
                    <v-flex class="pa-2" xs12 sm6>
                      <b-form-group
                        center
                        id="time"
                        :label="
                          $t(
                            'servicios.formularioExpedicion.recogidaHoraInicial'
                          )
                        "
                        label-for="time"
                      >
                        <b-form-input
                          autocomplete="off"
                          id="time"
                          type="time"
                          v-model="configuracion.Horarios.Vier.Inicio"
                        ></b-form-input>
                      </b-form-group>
                    </v-flex>
                    <v-flex class="pa-2" xs12 sm6>
                      <b-form-group
                        center
                        id="time"
                        :label="
                          $t(
                            'servicios.formularioExpedicion.recogidaHoraInicial'
                          )
                        "
                        label-for="time"
                      >
                        <b-form-input
                          autocomplete="off"
                          id="time"
                          type="time"
                          v-model="configuracion.Horarios.Vier.Fin"
                        ></b-form-input>
                      </b-form-group>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <!--Bloque remitente -->
              <v-toolbar-title class="pa-0 ma-0">Remitente</v-toolbar-title>
              <v-layout row wrap>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    :label="$t('domicilios.formulario.nombreApellidos')"
                    ref="NombreApellido"
                    v-model="configuracion.Remitente.Nombre"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    label="Email"
                    v-model="configuracion.Remitente.Email"
                    :rules="validations.emailRules"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    :label="$t('domicilios.formulario.telefono')"
                    v-model="configuracion.Remitente.Telefono"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    label="NIF"
                    v-model="configuracion.Remitente.Nif"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    :label="$t('domicilios.formulario.pais')"
                    v-model="configuracion.Remitente.Pais"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    :label="$t('domicilios.formulario.codigoPostal')"
                    v-model="configuracion.Remitente.CodigoPostal"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    :label="$t('domicilios.formulario.poblacion')"
                    v-model="configuracion.Remitente.Poblacion"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    :label="$t('domicilios.formulario.provincia')"
                    v-model="configuracion.Remitente.Provincia"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs6>
                  <v-text-field
                    :label="$t('domicilios.formulario.direccion')"
                    v-model="configuracion.Remitente.Direccion"
                  ></v-text-field>
                </v-flex>

                <v-flex class="pa-2" xs6>
                  <v-text-field
                    :label="$t('domicilios.formulario.observaciones')"
                    v-model="configuracion.Remitente.Observacion"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <!--Bloque Destinatario -->
              <v-toolbar-title class="pa-0 ma-0">Destinatario</v-toolbar-title>
              <v-layout row wrap>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    :label="$t('domicilios.formulario.nombreApellidos')"
                    ref="NombreApellido"
                    v-model="configuracion.Destinatario.Nombre"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    label="Email"
                    v-model="configuracion.Destinatario.Email"
                    :rules="validations.emailRules"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    :label="$t('domicilios.formulario.telefono')"
                    v-model="configuracion.Destinatario.Telefono"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    label="NIF"
                    v-model="configuracion.Destinatario.Nif"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    :label="$t('domicilios.formulario.pais')"
                    v-model="configuracion.Destinatario.Pais"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    :label="$t('domicilios.formulario.codigoPostal')"
                    v-model="configuracion.Destinatario.CodigoPostal"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    :label="$t('domicilios.formulario.poblacion')"
                    v-model="configuracion.Destinatario.Poblacion"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs12 sm6 md3>
                  <v-text-field
                    :label="$t('domicilios.formulario.provincia')"
                    v-model="configuracion.Destinatario.Provincia"
                  ></v-text-field>
                </v-flex>
                <v-flex class="pa-2" xs6>
                  <v-text-field
                    :label="$t('domicilios.formulario.direccion')"
                    v-model="configuracion.Destinatario.Direccion"
                  ></v-text-field>
                </v-flex>

                <v-flex class="pa-2" xs6>
                  <v-text-field
                    :label="$t('domicilios.formulario.observaciones')"
                    v-model="configuracion.Destinatario.Observacion"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <!--Bloque expedicion -->
              <v-toolbar-title class="pa-0 ma-0">Expedición</v-toolbar-title>
              <v-layout row wrap>
                <v-flex class="pa-2" xs12 sm4 md2>
                  <v-checkbox
                    color="primary"
                    v-model="configuracion.EntregaSabado"
                    :label="$t('servicios.formularioExpedicion.entregaSabado')"
                  ></v-checkbox>
                  <v-switch
                    color="primary"
                    v-model="configuracion.ForzadoDefinido"
                    label="Forz. Definido"
                    value="EntregaSabado"
                  ></v-switch>
                </v-flex>

                <v-flex class="pa-2" xs12 sm4 md2>
                  <v-checkbox
                    color="primary"
                    v-model="configuracion.AcuseRecibo"
                    :label="$t('servicios.formularioExpedicion.acuseRecibo')"
                  ></v-checkbox>
                  <v-switch
                    color="primary"
                    v-model="configuracion.ForzadoDefinido"
                    label="Forz. Definido"
                    value="AcuseRecibo"
                  ></v-switch>
                </v-flex>

                <v-flex class="pa-2" xs12 sm4 md2>
                  <v-checkbox
                    color="primary"
                    v-model="configuracion.Retorno"
                    :label="$t('servicios.formularioExpedicion.retorno')"
                  ></v-checkbox>
                  <v-switch
                    color="primary"
                    v-model="configuracion.ForzadoDefinido"
                    label="Forz. Definido"
                    value="Retorno"
                  ></v-switch>
                </v-flex>

                <v-flex class="pa-2" xs12 sm4 md2>
                  <v-checkbox
                    color="primary"
                    v-model="configuracion.Gestion"
                    :label="$t('servicios.formularioExpedicion.gestion')"
                  ></v-checkbox>
                  <v-switch
                    color="primary"
                    v-model="configuracion.ForzadoDefinido"
                    label="Forz. Definido"
                    value="Gestion"
                  ></v-switch>
                </v-flex>

                <v-flex class="pa-2" xs12 sm4 md2>
                  <v-checkbox
                    color="primary"
                    v-model="configuracion.AvisoEmailRemitente"
                    :label="
                      $t('servicios.formularioExpedicion.envioEmailRemitente')
                    "
                  ></v-checkbox>
                  <v-switch
                    color="primary"
                    v-model="configuracion.ForzadoDefinido"
                    label="Forz. Definido"
                    value="AvisoEmailRemitente"
                  ></v-switch>
                </v-flex>

                <v-flex class="pa-2" xs12 sm4 md2>
                  <v-checkbox
                    color="primary"
                    v-model="configuracion.AvisoEmailDestino"
                    :label="
                      $t('servicios.formularioExpedicion.envioEmailDestino')
                    "
                  ></v-checkbox>
                  <v-switch
                    color="primary"
                    v-model="configuracion.ForzadoDefinido"
                    label="Forz. Definido"
                    value="AvisoEmailDestino"
                  ></v-switch>
                </v-flex>

                <v-flex class="pa-2" xs12>
                  <PackageList
                    class="pa-1 ma-0"
                    :puedoEditar="true"
                    :Bultos="configuracion.Bultos"
                  ></PackageList>
                </v-flex>

                <v-flex class="pa-2" xs12 sm4 md2>
                  <b-form-group
                    id="insuredAmoun"
                    :label="
                      $t('servicios.formularioExpedicion.importeValorAsegurado')
                    "
                    label-for="insuredAmount"
                  >
                    <currency-input
                      :min="0"
                      v-model="configuracion.ImporteValor"
                      class="demo__currency-input"
                    />
                    <v-chip v-if="configuracion.ImporteValor > 0">
                      {{
                        $t("servicios.formularioExpedicion.aseguradoTodoRiesgo")
                      }}
                    </v-chip>
                  </b-form-group>
                  <v-switch
                    color="primary"
                    v-model="configuracion.ForzadoDefinido"
                    label="Forz. Definido"
                    value="Referencia"
                  />
                </v-flex>

                <v-flex class="pa-2" xs12 sm4 md2>
                  <b-form-group
                    center
                    id="refundAmount"
                    :label="
                      $t('servicios.formularioExpedicion.importeReembolso')
                    "
                    label-for="refundAmount"
                  >
                    <currency-input
                      :min="0"
                      v-model="configuracion.ImporteReembolso"
                      class="demo__currency-input"
                    />
                  </b-form-group>
                  <v-switch
                    color="primary"
                    v-model="configuracion.ForzadoDefinido"
                    label="Forz. Definido"
                    value="ImporteReembolso"
                  />
                </v-flex>

                <v-flex class="pa-2 pt-3" xs12 sm4 md2>
                  <v-checkbox
                    color="primary"
                    v-model="configuracion.ImporteDebido"
                    :label="$t('servicios.formularioExpedicion.porteDebido')"
                  ></v-checkbox>
                  <v-switch
                    color="primary"
                    v-model="configuracion.ForzadoDefinido"
                    label="Forz. Definido"
                    value="ImporteDebido"
                  />
                </v-flex>
              </v-layout>

              <hr />
              {{ this.configuracion }}
            </v-card-text>
            <v-card-text v-else>{{ this.mensajeError }}</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-else>
        <v-flex xs12>
          <v-card class="elevation-4" v-if="true">
            <v-toolbar dense color="primary" dark flat>
              <v-toolbar-title>Editar Configuracion</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <b>No dispone de permisos para editar</b>
              <br />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import PackageList from "../components/expeditions/ExpeditionPackagesV2";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "ExpedicionRapida",
  components: {
    PackageList,
  },
  data() {
    return {
      servicioSeleccionado: null,
      servicesTypes: [],
      cliente: "",
      configuracion: null,
      mensajeError: "Seleccione un cliente",
      ocultarCamposCargados: false, //TODO cambiar a true
      camposOcultos: [],
      validations: {
        emailRules: [
          //v => !!v || "E-mail necesario",
          (v) =>
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            ) ||
            /^$/.test(v) ||
            "E-mail no válido",
        ],
        standarRules: [(v) => !!v || "Campo necesario"],
        codigoPostal: [
          (v) =>
            this.codigoPostalNecesario(v) ||
            "Código Postal obligatorio en este país",
        ],
      },
    };
  },
  created: async function () {
    //console.log("PuedoEditar: "+this.PuedoEditarConfiguracion());
    this.cargarTiposServicio();
  },
  methods: {
    //Tipos de servicio
    ...mapActions("servicesTypes", ["getAllServicesTypes"]),
    async cargarTiposServicio() {
      this.$store.commit("setLoading", true, { root: true });
      try {
        /*let filtro = {
          PaisOrigen: this.configuracion.Remitente.Pais,
          CodigoPostalOrigen: this.configuracion.Remitente.CodigoPostal,
          PaisDestino: this.configuracion.Destinatario.Pais,
          CodigoPostalDestino: this.configuracion.Destinatario.CodigoPostal,
        };*/
        this.servicesTypes = await this.getAllServicesTypes();

        if (this.configuracion.CodigoTipoServicio) {
          let temp = this.servicesTypes.filter(
            (s) => s.CODIGO === this.configuracion.CodigoTipoServicio
          );
          if (temp) this.servicioSeleccionado = temp[0];
        }
      } catch (error) {
        console.log("Error: " + error);
      }

      this.$store.commit("setLoading", false, { root: true });
    },
    actualizarServicio() {
      if (this.servicioSeleccionado)
        this.configuracion.CodigoTipoServicio = this.servicioSeleccionado.CODIGO;
    },

    async guardar() {
      if (!this.configuracion || !this.cliente) return;
      this.$store.commit("setLoading", true, { root: true });
      let payload = {
        userLogin: this.cliente,
        configuracion: this.configuracion,
      };
      let temp = await this.guardarConfiguracionApi(payload);
      if (temp.estado) {
        this.$toast(temp.respuesta, {
          color: "green",
        });
        this.cargarConfiguracionCliente();
      } else {
        this.$toast(temp.respuesta.Message, {
          color: "red",
        });
      }
      this.$store.commit("setLoading", false, { root: true });
    },
    resetConfig() {
      this.configuracion = null;
      this.mensajeError = "Carga una configuración";
    },
    async eliminar() {
      //TODO
    },
    checkPonerDireccionClienteRemitente() {
      try {
        //console.log({ login: this.Login });
        if (!this.configuracion.Remitente.Direccion) {
          this.configuracion.Remitente.Nombre = this.Login.DOMICILIO.Nombre;
          this.configuracion.Remitente.Email = this.Login.DOMICILIO.Email;
          this.configuracion.Remitente.Pais = this.Login.DOMICILIO.Pais;
          this.configuracion.Remitente.Direccion = this.Login.DOMICILIO.Direccion;
          this.configuracion.Remitente.CodigoPostal = this.Login.DOMICILIO.CodigoPostal;
          this.configuracion.Remitente.Poblacion = this.Login.DOMICILIO.Poblacion;
          this.configuracion.Remitente.Telefono = this.Login.DOMICILIO.Telefono;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async cargarConfiguracionCliente() {
      if (!this.cliente) {
        this.$toast("Escriba un código de cliente", {
          color: "red",
        });
        return;
      }
      this.$store.commit("setLoading", true, { root: true });
      let temp = await this.getConfiguracionApi(this.cliente);
      if (temp.estado) {
        this.configuracion = temp.respuesta;
        this.checkPonerDireccionClienteRemitente();
      } else {
        this.configuracion = null;
        this.mensajeError = temp.respuesta.Message;
      }
      this.$store.commit("setLoading", false, { root: true });
    },
    async crearConfiguracionCliente() {
      if (!this.cliente) {
        this.$toast("Escriba un código de cliente", {
          color: "red",
        });
        return;
      }
      this.$store.commit("setLoading", true, { root: true });
      let temp = await this.crearConfiguracionApi(this.cliente);
      if (temp.estado) {
        this.$toast(temp.respuesta, {
          color: "green",
        });
        this.cargarConfiguracionCliente();
      } else {
        this.$toast(temp.respuesta.Message, {
          color: "red",
        });
      }
      this.$store.commit("setLoading", false, { root: true });
    },
    async eliminarConfiguracionCliente() {
      if (!this.cliente) {
        this.$toast("Escriba un código de cliente", {
          color: "red",
        });
        return;
      }
      try {
        await this.$dialog.confirm(
          "¿Desea eliminar la configuración del cliente " + this.cliente + "?"
        );
        this.$store.commit("setLoading", true, { root: true });
        let temp = await this.eliminarConfiguracionApi(this.cliente);
        if (temp.estado) {
          this.$toast(temp.respuesta, {
            color: "green",
          });
          this.resetConfig();
        } else {
          this.$toast(temp.respuesta.Message, {
            color: "red",
          });
        }
        this.$store.commit("setLoading", false, { root: true });
      } catch (error) {}
    },

    //Vuex
    ...mapGetters("Auth", ["PuedoEditarConfiguracion"]),
    ...mapActions({
      getConfiguracionApi: "servicioRapido/getConfiguracionApi",
      crearConfiguracionApi: "servicioRapido/crearConfiguracionApi",
      eliminarConfiguracionApi: "servicioRapido/eliminarConfiguracionApi",
      guardarConfiguracionApi: "servicioRapido/guardarConfiguracionApi",
    }),
    ...mapState(["isMobile"]),
  },
  computed: {
    ...mapGetters({ Login: "Auth/Usuario" }),
  },
};
</script>
